import React, { useMemo } from "react";
import { getVaultVersionHistoryEntries } from "./qmsVaultVersionHistoryUtils";

function VersionHistoryCard({ entry, onOpenVersion }) {
  return (
    <article className="qms-vault-audit__card qms-vault-version-history__card">
      <div className="qms-vault-audit__card-head">
        <div className="qms-vault-audit__card-title-wrap">
          <span className="qms-vault-version-history__icon" aria-hidden="true">
            <i className="fas fa-file-alt" />
          </span>
          <h6 className="qms-vault-audit__card-title">{entry.displayTitle || "—"}</h6>
        </div>
        <span className="qms-vault-version-history__version-badge">
          {entry.versionLabel}
        </span>
      </div>

      <div className="qms-vault-version-history__doc-id">{entry.documentId || "—"}</div>

      <div className="qms-vault-audit__card-meta">
        <span className="qms-vault-audit__card-meta-item">
          <i className="far fa-user" aria-hidden="true" />
          Owner: {entry.owner}
        </span>
        <span className="qms-vault-audit__card-meta-item">
          <i className="far fa-clock" aria-hidden="true" />
          Modified: {entry.modified}
        </span>
        <span className="qms-vault-audit__card-meta-item">
          <i className="fas fa-user-check" aria-hidden="true" />
          Superseded by: {entry.supersededBy}
        </span>
        <span className="qms-vault-audit__card-meta-item">
          <i className="far fa-calendar-alt" aria-hidden="true" />
          Superseded on: {entry.supersededOn}
        </span>
      </div>

      <div className="qms-vault-audit__card-footer">
        <button
          type="button"
          className="btn btn-sm btn-link p-0 qms-vault-audit__details-link"
          onClick={() => onOpenVersion?.(entry.row)}
        >
          Open preview
        </button>
      </div>
    </article>
  );
}

function QmsVaultVersionHistoryPanel({
  workspaceResponse,
  onOpenVersion,
  loading = false,
}) {
  const entries = useMemo(
    () => getVaultVersionHistoryEntries(workspaceResponse),
    [workspaceResponse],
  );

  return (
    <div className="qms-doc-workspace__panel qms-vault-audit qms-vault-version-history">
      <div className="qms-doc-workspace__panel-head qms-vault-audit__head">
        <div>
          <h6 className="qms-doc-workspace__panel-title">Version history</h6>
          <p className="qms-doc-workspace__panel-desc qms-vault-audit__desc">
            Open a previous version to preview its file only. Reviewers, approvers, comments,
            audit log, and all other workspace data stay with the current version.
          </p>
        </div>
      </div>

      <div className="qms-doc-workspace__panel-body qms-vault-audit__body">
        {loading ? (
          <div className="qms-vault-audit__loading">
            <i className="fas fa-spinner fa-spin" aria-hidden="true" />
            <span>Loading version history…</span>
          </div>
        ) : (
          <div className="qms-vault-version-history__list-scroll">
            {entries.length === 0 ? (
              <div className="qms-vault-audit__empty">No previous versions found.</div>
            ) : (
              <div className="qms-vault-audit__list">
                {entries.map((entry) => (
                  <VersionHistoryCard
                    key={entry.id}
                    entry={entry}
                    onOpenVersion={onOpenVersion}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default QmsVaultVersionHistoryPanel;
